<template>
    <div class="paging-container">
       <span class="little-badge paging-helper">
        {{ (pagination || {count:0}).count }} tracks
        </span>
        <b-pagination
            v-if="pagination && (pagination.pageCount >= 1 || pagination.page > 0)"
            v-model="currentPage"
            :total-rows="pagination.count"
            :per-page="pagination.pageSize"
            aria-controls="my-table"
        ></b-pagination>
        <template v-if="pageSizeOptions.length > 1">
            <div class="pagination-sizes">
                <select
                    :value="currentPageSize"
                    @input="handlePageSize"
                >
                    <option v-for="size in pageSizeOptions" :key="size" :value="size">
                        per {{ size }}
                    </option>
                </select>
                <i class="fas fa-chevron-down"></i>
            </div>
        </template>
    </div>
</template>
<script>
    export default {
        props: {
            pagination : {type:Object},
            sizes: {
                type: [Number, Array],
                default: 100
            }
        },
        data() {
            return {
                currentPage: (this.pagination || {page:1}).page || 1,
                currentPageSize: (this.pagination || { pageSize: 100 }).pageSize
            }
        },
        computed: {
            pageSizeOptions () {
                if (Array.isArray(this.sizes)) {
                    return this.sizes
                }

                return [this.sizes]
            }
        },
        watch:{
            pagination: {
                handler () {
                    this.currentPage =(this.pagination || {page:1}).page
                    this.currentPageSize = (this.pagination || { pageSize: 100 }).pageSize
                },
                deep: true
            },
            currentPage(){
                this.$emit('page', this.currentPage)
            }
        },
        methods: {
            handlePageSize (e) {
                this.$emit('page-size', +e.target.value)
            }
        }
    }
</script>

<style scoped>
.pagination-sizes {
    position: relative;
    margin-left: 1rem;
}

.pagination-sizes select {
    cursor: pointer;
    outline: 0;
    width: 110px;
    appearance: none;
    border: 1px solid #dee2e6;
    border-radius: .24rem;
    color: #8c8c8c;
    font-size: 14px;
    height: 38px;
    line-height: 1.25;
    padding: .5rem .75rem;
}

.pagination-sizes select:hover,
.pagination-sizes select:focus {
    border-color: #aaa;
}

.pagination-sizes select:focus {
    color: initial;
}

.pagination-sizes i {
    color: #8c8c8c;
    position: absolute;
    font-size: 12px;
    right: 12px;
    top: 13px;
    pointer-events: none;
}
</style>
